import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHaptic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHaptic"><Path d="M2.5 9.5C4.10453 9.5 5.68267 6.5 7.25 6.5C8.83902 6.5 10.4169 9.5 12 9.5C13.5729 9.5 15.151 6.5 16.75 6.5C18.3085 6.5 19.8869 9.5 21.5 9.5M2.5 17.5C4.10453 17.5 5.68267 14.5 7.25 14.5C8.83902 14.5 10.4169 17.5 12 17.5C13.5729 17.5 15.151 14.5 16.75 14.5C18.3085 14.5 19.8869 17.5 21.5 17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHaptic;
